// Output Format Configuration
// This file centralizes output format constants from environment variables

export const OUTPUT_FORMATS = {
  IMAGE: {
    ID: parseInt(process.env.REACT_APP_IMAGE_FORMAT_ID) || 1,
    NAME: 'IMAGE'
  },
  VIDEO: {
    ID: parseInt(process.env.REACT_APP_VIDEO_FORMAT_ID) || 14,
    NAME: 'VIDEO'
  }
};

// Helper functions for format checking
export const isImageFormat = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.IMAGE.ID;
};

export const isVideoFormat = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.VIDEO.ID;
};

// Get format name by ID
export const getFormatNameById = (outputFormatId) => {
  if (outputFormatId === OUTPUT_FORMATS.IMAGE.ID) return OUTPUT_FORMATS.IMAGE.NAME;
  if (outputFormatId === OUTPUT_FORMATS.VIDEO.ID) return OUTPUT_FORMATS.VIDEO.NAME;
  return 'UNKNOWN';
};

// Validate if format ID is valid
export const isValidFormatId = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.IMAGE.ID || outputFormatId === OUTPUT_FORMATS.VIDEO.ID;
};

export default OUTPUT_FORMATS;
